import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  resetForm: false,
  invites: {
    loading: false,
    error: null,
    data: [],
    totalPages: 0,
    totalRecords: 0,
    page: 0,
    pageSize: 0,
    sortOn: '',
    sortDir: '',
  },
  corpReports: {
    loading: false,
    error: null,
    data: [],
    totalPages: 0,
    totalRecords: 0,
    page: 0,
    pageSize: 0,
    sortOn: '',
    sortDir: '',
  },
  comments: {
    reportId: 0,
    loading: false,
    error: null,
    data: [],
    totalPages: 0,
    totalRecords: 0,
    page: 0,
    pageSize: 0,
    sortOn: '',
    sortDir: '',
  },
  reportsAnalyticsData: {
    loading: false,
    data: [],
    error: null,
  },
  recentlyAddedReports: {
    loading: false,
    error: null,
    data: [],
    totalPages: 0,
    totalRecords: 0,
    page: 0,
    pageSize: 0,
    sortOn: '',
    sortDir: '',
  },
};

export const validatorSlice = createSlice({
  name: 'validators',
  initialState,
  reducers: {
    sendInviteRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    sendInviteSuccess: (state, {payload}) => {
      state.loading = false;
      state.resetForm = payload;
    },
    sendInviteError: (state, {payload}) => {
      state.loading = false;
      state.error = payload;
    },
    fetchInvitesRequest: (state) => {
      state.invites.loading = true;
      state.invites.error = null;
    },
    fetchInvitesSuccess: (state, {payload}) => {
      const {data, page, pageSize, totalPages, totalRecords, sortOn, sortDir} =
        payload;
      state.invites.loading = false;
      state.invites.data = data;
      state.invites.page = page;
      state.invites.pageSize = pageSize;
      state.invites.totalPages = totalPages;
      state.invites.totalCount = totalRecords;
      state.invites.sortOn = sortOn;
      state.invites.sortDir = sortDir;
    },
    fetchInvitesError: (state, {payload}) => {
      state.invites.loading = false;
      state.invites.error = payload;
    },
    fetchCorpReportsRequest: (state) => {
      state.corpReports.loading = true;
      state.corpReports.error = null;
    },
    fetchCorpReportsSuccess: (state, {payload}) => {
      const {data, page, pageSize, totalPages, totalRecords, sortOn, sortDir} =
        payload;
      state.corpReports.loading = false;
      state.corpReports.data = data;
      state.corpReports.page = page;
      state.corpReports.pageSize = pageSize;
      state.corpReports.totalPages = totalPages;
      state.corpReports.totalCount = totalRecords;
      state.corpReports.sortOn = sortOn;
      state.corpReports.sortDir = sortDir;
    },
    fetchCorpReportsError: (state, {payload}) => {
      state.corpReports.loading = false;
      state.corpReports.error = payload;
    },
    updateReportStatusRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateReportStatusSuccess: (state) => {
      state.loading = false;
      state.comments.reportId = 0; // to reload comments
    },
    updateReportStatusError: (state, {payload}) => {
      state.loading = false;
      state.error = payload;
    },
    fetchReportCommentsRequest: (state) => {
      state.comments.loading = true;
      state.comments.error = null;
    },
    fetchReportCommentsSuccess: (state, {payload}) => {
      const {
        reportId,
        data,
        page,
        pageSize,
        totalPages,
        totalRecords,
        sortOn,
        sortDir,
      } = payload;
      state.comments.reportId = reportId;
      state.comments.loading = false;
      state.comments.data = data;
      state.comments.page = page;
      state.comments.pageSize = pageSize;
      state.comments.totalPages = totalPages;
      state.comments.totalCount = totalRecords;
      state.comments.sortOn = sortOn;
      state.comments.sortDir = sortDir;
    },
    fetchReportCommentsError: (state, {payload}) => {
      state.comments.loading = false;
      state.comments.error = payload;
      state.comments.data = [];
      state.comments.reportId = 0;
    },
    fetchReportsAnalyticsDataRequest: (state) => {
      state.reportsAnalyticsData.loading = true;
      state.reportsAnalyticsData.error = null;
    },
    fetchReportsAnalyticsDataSuccess: (state, {payload}) => {
      state.reportsAnalyticsData.loading = false;
      state.reportsAnalyticsData.data = payload;
    },
    fetchReportsAnalyticsDataError: (state, {payload}) => {
      state.reportsAnalyticsData.loading = false;
      state.reportsAnalyticsData.error = payload;
      state.reportsAnalyticsData.data = [];
    },
    fetchRecentlyAddedReportsRequest: (state) => {
      state.recentlyAddedReports.loading = true;
      state.recentlyAddedReports.error = null;
    },
    fetchRecentlyAddedReportsSuccess: (state, {payload}) => {
      const {data, page, pageSize, totalPages, totalRecords, sortOn, sortDir} =
        payload;
      state.recentlyAddedReports.loading = false;
      state.recentlyAddedReports.data = data;
      state.recentlyAddedReports.page = page;
      state.recentlyAddedReports.pageSize = pageSize;
      state.recentlyAddedReports.totalPages = totalPages;
      state.recentlyAddedReports.totalCount = totalRecords;
      state.recentlyAddedReports.sortOn = sortOn;
      state.recentlyAddedReports.sortDir = sortDir;
    },
    fetchRecentlyAddedReportsError: (state, {payload}) => {
      state.recentlyAddedReports.loading = false;
      state.recentlyAddedReports.error = payload;
    },
  },
});

export const {
  sendInviteRequest,
  sendInviteSuccess,
  sendInviteError,
  fetchInvitesRequest,
  fetchInvitesSuccess,
  fetchInvitesError,
  fetchCorpReportsRequest,
  fetchCorpReportsSuccess,
  fetchCorpReportsError,
  updateReportStatusRequest,
  updateReportStatusSuccess,
  updateReportStatusError,
  fetchReportCommentsRequest,
  fetchReportCommentsSuccess,
  fetchReportCommentsError,
  fetchReportsAnalyticsDataRequest,
  fetchReportsAnalyticsDataSuccess,
  fetchReportsAnalyticsDataError,
  fetchRecentlyAddedReportsRequest,
  fetchRecentlyAddedReportsSuccess,
  fetchRecentlyAddedReportsError,
} = validatorSlice.actions;

export default validatorSlice.reducer;
